import { createAction, props } from '@ngrx/store';
import { PHASE_THREE } from '../../../model/phases.model';

export const ADD_PHASE_THREE = createAction(
  'ADD_PHASE_THREE',
  props<{ payload: PHASE_THREE }>()
);

// export const GET_PHASE_ONE_DATA = createAction('GET_PHASE_ONE_DATE');
